// import axios from 'axios'

var instance = null

export default class GoogleDirectionsCalculatorApi {
  static getInstance() {
    if (!instance) {
      instance = new GoogleDirectionsCalculatorApi()
    }

    return instance
  }

  async execute(data) {
    try {
      this.validateGoogleConstant()
      const directions = await this.calculateDirections(data)

      return directions
    } catch (error) {
      this.handleErrors(error)
    }
  }

  validateGoogleConstant() {
    if (window.google) {
      return
    }

    throw new Error('Google constant is uninitialized, it\'s impossible to request to directions API')
  }

  async calculateDirections(data) {
    return new Promise(function(resolve, reject) {
      const directionsService = new window.google.maps.DirectionsService()

      directionsService.route(this.prepareRequestParams(data), function(response, status) {
        if (status === window.google.maps.DirectionsStatus.OK) {
          return resolve(response)
        }

        reject(new Error('Error in directions api'))
      })
    }.bind(this))
  }

  prepareRequestParams(data) {
    return {
      origin: data.origin,
      destination: data.destination,
      travelMode: window.google.maps.DirectionsTravelMode.DRIVING
    }
  }

  handleErrors(error) {
    console.log(error)
    throw error
  }
}
